import { render } from "./ssl-parameters.vue?vue&type=template&id=61f4e359"
import script from "./ssl-parameters.vue?vue&type=script&lang=js"
export * from "./ssl-parameters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__